module.exports = __webpack_public_path__ + "04_long_black.0fe912be.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/04_long_black.png
// module id = DRrT
// module chunks = 0